"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = function Loader(_ref) {
  var show = _ref.show,
      text = _ref.text,
      spinnerSize = _ref.spinnerSize,
      textSize = _ref.textSize,
      className = _ref.className;
  return show && /*#__PURE__*/_react.default.createElement("div", {
    className: "loader-container ".concat(className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "loader-content"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "loader-spinner",
    style: {
      '--spinnerSize': "".concat(spinnerSize, "px")
    }
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: spinnerSize / 2,
    cy: spinnerSize / 2,
    r: spinnerSize / 2 - 3
  })), /*#__PURE__*/_react.default.createElement("h6", {
    className: "loader-text",
    style: {
      '--textSize': "".concat(textSize, "px")
    }
  }, text)));
};

Loader.propTypes = {
  show: _propTypes.default.bool.isRequired,
  text: _propTypes.default.string,
  spinnerSize: _propTypes.default.number,
  textSize: _propTypes.default.number,
  className: _propTypes.default.string
};
Loader.defaultProps = {
  text: '',
  spinnerSize: 40,
  textSize: 13,
  className: ''
};
var _default = Loader;
exports.default = _default;